var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    staticClass: "app-icon",
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_vm.name === 'close' ? [_c('path', {
    attrs: {
      "d": "M6 6l12 12M18 6L6 18"
    }
  })] : _vm.name === 'plus' ? [_c('path', {
    attrs: {
      "d": "M12 5v14M5 12h14"
    }
  })] : _vm.name === 'edit' ? [_c('path', {
    attrs: {
      "d": "M4 20h4l10.6-10.6a2.1 2.1 0 0 0-3-3L5 17v3z"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.8 8.2l3 3"
    }
  })] : _vm.name === 'trash' ? [_c('path', {
    attrs: {
      "d": "M4.5 7h15M9 7V4.5h6V7M7 7l.8 13h8.4L17 7M10 10.5v6M14 10.5v6"
    }
  })] : _vm.name === 'link' ? [_c('path', {
    attrs: {
      "d": "M10 13a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.7 1.7M14 11a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.7-1.7"
    }
  })] : _vm.name === 'mail' ? [_c('rect', {
    attrs: {
      "x": "3",
      "y": "5",
      "width": "18",
      "height": "14",
      "rx": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.5 7l7.5 6 7.5-6"
    }
  })] : _vm.name === 'phone' ? [_c('path', {
    attrs: {
      "d": "M7.2 3.5l2.2 4.1-1.8 1.8a15 15 0 0 0 7 7l1.8-1.8 4.1 2.2-.7 3.2a2 2 0 0 1-2 1.5C9.4 20.8 3.2 14.6 2.5 6.2A2 2 0 0 1 4 4.2l3.2-.7z"
    }
  })] : _vm.name === 'check' ? [_c('path', {
    attrs: {
      "d": "M5 12.5l4.2 4.2L19 7"
    }
  })] : _vm.name === 'menu' ? [_c('path', {
    attrs: {
      "d": "M5 7h14M5 12h14M5 17h14"
    }
  })] : _vm.name === 'clock' ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "8.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 7v5l3.4 2"
    }
  })] : _vm.name === 'repeat' ? [_c('path', {
    attrs: {
      "d": "M17.5 7H7.8A4.8 4.8 0 0 0 3 11.8"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.5 4l3 3-3 3"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.5 17h9.7a4.8 4.8 0 0 0 4.8-4.8"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.5 20l-3-3 3-3"
    }
  })] : _vm.name === 'calendar' ? [_c('rect', {
    attrs: {
      "x": "3.5",
      "y": "5",
      "width": "17",
      "height": "15",
      "rx": "2.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.5 3v4M16.5 3v4M3.5 9.5h17M7.5 13h.01M12 13h.01M16.5 13h.01M7.5 17h.01M12 17h.01"
    }
  })] : _vm.name === 'users' ? [_c('path', {
    attrs: {
      "d": "M8.5 12.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM15.8 11a2.8 2.8 0 1 0 0-5.6"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.8 20a5.7 5.7 0 0 1 11.4 0M15.2 14.3a4.8 4.8 0 0 1 6 4.7"
    }
  })] : _vm.name === 'briefcase' ? [_c('rect', {
    attrs: {
      "x": "3",
      "y": "7",
      "width": "18",
      "height": "13",
      "rx": "2.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M8 7V5.2A2.2 2.2 0 0 1 10.2 3h3.6A2.2 2.2 0 0 1 16 5.2V7M3 12.5c5.8 2 12.2 2 18 0M10 13.8h4"
    }
  })] : _vm.name === 'print' ? [_c('path', {
    attrs: {
      "d": "M6.5 8V4.5h11V8M6.5 16H4.8A1.8 1.8 0 0 1 3 14.2v-4A1.8 1.8 0 0 1 4.8 8.4h14.4a1.8 1.8 0 0 1 1.8 1.8v4a1.8 1.8 0 0 1-1.8 1.8h-1.7"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.5 14.5h11v5h-11zM17.5 11h.01"
    }
  })] : _vm.name === 'book' ? [_c('path', {
    attrs: {
      "d": "M4.5 5.5A2.5 2.5 0 0 1 7 3h11v16H7a2.5 2.5 0 0 0-2.5 2.5z"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.5 5.5v15"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 7h6M8.5 11h6"
    }
  })] : _vm.name === 'clipboard' ? [_c('rect', {
    attrs: {
      "x": "5",
      "y": "4.5",
      "width": "14",
      "height": "16",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M9 4.5V3.8A1.8 1.8 0 0 1 10.8 2h2.4A1.8 1.8 0 0 1 15 3.8v.7M9 10h6M9 14h6"
    }
  })] : _vm.name === 'cloud' ? [_c('path', {
    attrs: {
      "d": "M7 18.5h10.3a3.7 3.7 0 0 0 .5-7.4A6.1 6.1 0 0 0 6.3 9.4 4.6 4.6 0 0 0 7 18.5z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 10v6M9.7 12.3L12 10l2.3 2.3"
    }
  })] : _vm.name === 'download' ? [_c('path', {
    attrs: {
      "d": "M12 3v11M8.5 10.5L12 14l3.5-3.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 16.5v2A2.5 2.5 0 0 0 7.5 21h9a2.5 2.5 0 0 0 2.5-2.5v-2"
    }
  })] : _vm.name === 'megaphone' ? [_c('path', {
    attrs: {
      "d": "M4 9h4l11-5v16l-11-5H4V9zM8 15l2 6h3l-2-5M22 9v6"
    }
  })] : _vm.name === 'settings' ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.6v-.2h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1z"
    }
  })] : _vm.name === 'feedback' ? [_c('path', {
    attrs: {
      "d": "M4.5 4.5h15a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H10l-5.5 3v-14a2 2 0 0 1 2-2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8v4M12 15h.01"
    }
  })] : _vm.name === 'bell' ? [_c('path', {
    attrs: {
      "d": "M18 8a6 6 0 0 0-12 0c0 6.8-3 7.2-3 9h18c0-1.8-3-2.2-3-9z"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.7 20a2.7 2.7 0 0 0 4.6 0"
    }
  })] : _vm.name === 'info' ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 10.5v6M12 7.5h.01"
    }
  })] : _vm.name === 'sparkles' ? [_c('path', {
    attrs: {
      "d": "M12 3l1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2L12 3zM18.5 13l.7 2.3 2.3.7-2.3.7-.7 2.3-.7-2.3-2.3-.7 2.3-.7.7-2.3zM5 14l.8 2.5 2.5.8-2.5.8L5 20.5l-.8-2.4-2.5-.8 2.5-.8L5 14z"
    }
  })] : _vm.name === 'arrow-right' ? [_c('path', {
    attrs: {
      "d": "M5 12h14M14 7l5 5-5 5"
    }
  })] : _vm.name === 'chat' ? [_c('path', {
    attrs: {
      "d": "M4.5 4h11a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5H9l-4.5 3v-14z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18 8.5h1.2a2.3 2.3 0 0 1 2.3 2.3v7.7l-3.6-2.4H15"
    }
  }), _c('path', {
    attrs: {
      "d": "M8 8h6M8 11h4"
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }